import React from "react";
import PropTypes from "prop-types";
import { ROUTES } from "../../constants/clientRoutes";
import { NavLink } from "react-router-dom";

/**
 * List of navigation elements not returned by the api
 *
 * @param display
 * @param onLogOut
 * @returns {null|*}
 * @constructor
 */
export const LoggedInItems = ({ display, onLogOut, onNavigate }) => {
  if (!display) {
    return null;
  }

  return (
    <React.Fragment>
      <li id={"AccountSettingsIndex"} className={"menu-item menu-state-default"}>
        <span className="badge-wrap">
          <NavLink to={ROUTES.SETTINGS.PERSONAL_DETAILS} id="AccountSettingsIndex" activeClassName="active" onClick={onNavigate}>
            Settings
          </NavLink>
        </span>
      </li>
      <li
        id="account-support"
        className="menu-item menu-state-default menu-last"
      >
        <div id="support-button">
          <button
            id="LogOut"
            type="button"
            className="btn btn-primary btn-sm btn-narrow"
            onClick={onLogOut}
          >
            <span className="btn-text-padding">Log Out</span>
          </button>
        </div>
      </li>
    </React.Fragment>
  );
};

LoggedInItems.propTypes = {
  /** Display toggle */
  display: PropTypes.bool.isRequired,
  /** Log out callback */
  onLogOut: PropTypes.func.isRequired,
  onNavigate: PropTypes.func.isRequired,
};

export default LoggedInItems;
